"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileShredder: function() {
        return FileShredder;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileShredder = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V12H22C22.5523 12 23 12.4477 23 13C23 13.5523 22.5523 14 22 14H20H4H2C1.44772 14 1 13.5523 1 13C1 12.4477 1.44772 12 2 12H3V4ZM5 12H19V9H14C13.4477 9 13 8.55228 13 8V3H6C5.44772 3 5 3.44772 5 4V12ZM15 4.41421L17.5858 7H15V4.41421ZM4 16C4.55228 16 5 16.4477 5 17V19C5 19.5523 4.55228 20 4 20C3.44772 20 3 19.5523 3 19V17C3 16.4477 3.44772 16 4 16ZM8 16C8.55228 16 9 16.4477 9 17V20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20V17C7 16.4477 7.44772 16 8 16ZM12 16C12.5523 16 13 16.4477 13 17V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V17C11 16.4477 11.4477 16 12 16ZM16 16C16.5523 16 17 16.4477 17 17V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V17C15 16.4477 15.4477 16 16 16ZM21 17V19C21 19.5523 20.5523 20 20 20C19.4477 20 19 19.5523 19 19V17C19 16.4477 19.4477 16 20 16C20.5523 16 21 16.4477 21 17Z",
        fill: "currentColor"
    })
}), "FileShredder");
const _default = FileShredder;
